import $ from 'jquery';
import Blazy from 'blazy';
import { uniqueId } from '../../utils/data';

/**
 * Lazily loads images, backgrounds, videos and iframes.
 *
 * @see http://dinbror.dk/blog/blazy/
 * @param context
 */
export default function lazyLoadDirective(context=document.body) {
    let container = 'window';

	/*
	 * Problem:
	 *   Blazy library only supports a string selector for the container element.
	 *   This means that the `context` argument above cannot be passed directly as a DOM element to the Blazy
	 *   initialisation function.
	 *
	 * Solution:
	 *   Generate a unique attribute for the element, add it to the element, then use a selector targeting that
	 *   attribute.
	 */
	if (context !== document.body) {
		const uniqueAttr = 'data-' + uniqueId();
		container = `[${uniqueAttr}]`;

		$(context).attr(uniqueAttr, true);
	}

    const blazy = new Blazy({
        container,
        selector: '[sw-lazy-load]',
        src: 'sw-lazy-load',
        successClass: 'is-ready',
        errorClass: 'is-broken',
        error: function(ele, msg){
            let lazyImg = $(ele).attr('sw-lazy-load');
            $(ele).attr('src', lazyImg);
            $(ele).addClass('is-ready');
        }
    });

	$(() => blazy.revalidate());
}



// WEBPACK FOOTER //
// ./source/scripts/directives/scroll/lazy-load.js